import http from '../../util/http'
/**
 * @author 王怀志
 * @description 人员名单表相关
 */
export default class PersonManage{
  constructor(){
    this.PREFIX = "/share-foreign"
  }
  /**
   *获取人员列表
   *
   * @param {object} data
   * @param {String} data.companyId
   * @param {String} data.name
   * @param {String} data.cartNo
   * @param {String[]} data.passportNo - 护照号
   * @param {String[]} data.validityDateStart - 开始日期
   * @param {String[]} data.validityDateEnd - 结束日期
   * @returns
   * @memberof PersonManage
   */
  list(data) {
    let url = this.PREFIX + "/visa/personInfo/personPage"
    return http.post(url, data)
  }
  /**
   *新增或编辑人员
   *
   * @param {object} data
   * @param {String} data.birthday
   * @param {String} data.cardType
   * @param {String} data.cartNo
   * @param {String} data.companyId
   * @param {String} data.duty
   * @param {String} data.dutyLevel
   * @param {String} data.dutyNature
   * @param {String} data.extIde
   * @param {String} data.extIdeAddNote
   * @param {String} data.extUnit
   * @param {String} data.fingerprint
   * @param {String} data.fingerprintNo
   * @param {String} data.firstName
   * @param {String} data.firstNameEn
   * @param {String} data.issueDate
   * @param {String} data.lastName
   * @param {String} data.lastNameEn
   * @param {String} data.level
   * @param {String} data.makeNew
   * @param {String} data.name
   * @param {String} data.nation
   * @param {String} data.orderNo
   * @param {String} data.passportNo
   * @param {String} data.passportPage
   * @param {String} data.personInfoId
   * @param {String} data.placeBirth
   * @param {String} data.polCase
   * @param {String} data.qmUp
   * @param {String} data.rankSeq
   * @param {String} data.remarks
   * @param {String} data.residenceBooklet
   * @param {String} data.sex
   * @param {String} data.sfzUp
   * @param {String} data.signItemPersonId
   * @param {String} data.signature
   * @param {String} data.userType
   * @param {String} data.validPassportPhoto
   * @param {String} data.validityDate
   * @param {String} data.workUnit
   * @param {String} data.zwUp	- 指纹是否上传到外交部是(Y)否(N)
   * @returns
   * @memberof PersonManage
   */
  update(data) {
    let url = this.PREFIX + "/visa/personInfo/addOrEdit"
    return http.post(url, data)
  }
  /**
   *获取人员详情
   *
   * @param {Object} data
   * @param {String} data.personInfoId
   * @returns
   * @memberof PersonManage
   */
  detail(data){
    let url = this.PREFIX+"/visa/personInfo/getPersonInfo"
    return http.post(url,data)
  }
  /**
   * 提交指纹数据
   * @param {*} data
   */
  submit(data){
    let url = this.PREFIX+"/visa/stateItemInfo/uploadFingerInfo"
    return http.post(url,data)
  }
  submitNew(data){
    let urlnew = this.PREFIX+"/visa/stateItemInfo/uploadFingerInfoMfa"
    return http.post(urlnew,data)
  }
  uploadBioMfa(data){
    let urlnew = this.PREFIX+"/visa/stateItemInfo/uploadBioMfa"
    return http.post(urlnew,data)
  }
  /**
   * 批量提交指纹
   * @param {{personInfoIds: Array<String>}} data
   */
  submitByBatch(data){
    let url = this.PREFIX+ "/visa/personInfo/uploadBatchFingerInfo"
    return http.post(url,data)
  }
  submitByBatchNew(data){
    let urlnew = this.PREFIX+ "/visa/personInfo/uploadBatchFingerInfoMfa"
    return http.post(urlnew,data)
  }
  // 批量提交签名
  uploadBatchSignatureInfoMfa(data){
    let urlnew = this.PREFIX+ "/visa/personInfo/uploadBatchSignatureInfoMfa"
    return http.post(urlnew,data)
  }
  /**
   *获取人员综合信息
   *
   * @param {{personInfoId: String}} data
   * @returns
   * @memberof PersonManage
   */
  allInfo(data){
    let url = this.PREFIX+"/visa/personInfo/getPersonAllInfo"
    return http.post(url,data)
  }

   /**
   *获取人员出生地
   *
   */
   getAllProvinceList(data){
    let url = this.PREFIX+"/sysarea/getAreaList"
    return http.post(url,data)
  }

  // 合并人员
  mergePersonnel(data){
    let url = this.PREFIX+"/visa/personInfo/mergePersonnel"
    return http.post(url,data)
  }
  /**
   * 校验编码与上传的是否一致
   * @param {{receiptCode: String,path: String}} data
   */
  checkReceiptCode(data){
    let url = this.PREFIX+"/visa/personInfo/checkReceiptCode"
    return http.post(url,data)
  }
  /**
   * 核查
   * @param {{personInfoId: String}} data
   */
  checkSignAndFingerMfa(data){
    let urlnew = this.PREFIX+"/visa/stateItemInfo/checkSignAndFingerMfa"
    return http.post(urlnew,data)
  }
  /**
   * 删除
   * @param {{personInfoId: String}} data
   */
  deletePerson(data){
    let urlnew = this.PREFIX+"/visa/personInfo/deletePerson"
    return http.post(urlnew,data)
  }
}
